export default {
    'OPERACION_ENTRADA': (state, mutation) => {
        state.entrada = mutation.entrada
    }
}